// Normalizes Part A session fields for document generation API payloads.

export type ExportPilotFunction = 'Captain' | 'First Officer' | 'Instructor Trainee' | 'Other';

export type ExportOverallResult = 'Pass' | 'Partial Pass' | 'Fail' | 'Incomplete';

/** Maps crew role codes to the pilotFunction enum accepted by /api/generate-document. */
export function pilotFunctionForExport(
  crewRole: string | null | undefined,
  fallback?: string | null,
): ExportPilotFunction {
  switch (crewRole) {
    case 'captain':
    case 'captain_2':
      return 'Captain';
    case 'first_officer':
    case 'first_officer_2':
      return 'First Officer';
    case 'instructor_trainee':
      return 'Instructor Trainee';
    default:
      break;
  }

  if (
    fallback === 'Captain' ||
    fallback === 'First Officer' ||
    fallback === 'Instructor Trainee' ||
    fallback === 'Other'
  ) {
    return fallback;
  }

  return 'Other';
}

/** Maps DB overall_result values to the enum accepted by /api/generate-document. */
export function overallResultForExport(value: string | null | undefined): ExportOverallResult {
  if (value === 'Pass' || value === 'Partial Pass' || value === 'Fail' || value === 'Incomplete') {
    return value;
  }
  return 'Incomplete';
}
